/*
 * <sf-home-slider>: the one carousel behind every homepage slider (hero banner, lab proof, review cards,
 * customer videos). The track is a native scroll-snap row, so phones keep their swipe; this adds the
 * arrows ([data-prev] / [data-next], wrapping round like the competitor), dots ([data-dots], built here,
 * one per slide) or a progress bar ([data-bar]), and fires 'sfh:slide' {index, slide} when the visible
 * slide changes (the hero uses it to swap the caption shown under the picture on phones).
 */
(function () {
  'use strict';
  if (customElements.get('sf-home-slider')) return;

  class SfHomeSlider extends HTMLElement {
    connectedCallback() {
      if (this.track) return; // the theme editor may re-attach the same node
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.slides = Array.prototype.slice.call(this.track.children);
      if (!this.slides.length) return;
      this.dots = this.querySelector('[data-dots]');
      this.bar = this.querySelector('[data-bar]');
      this.index = 0;
      var self = this;
      if (this.dots) this.buildDots();
      this.querySelectorAll('[data-prev]').forEach(function (b) { b.addEventListener('click', function () { self.step(-1); }); });
      this.querySelectorAll('[data-next]').forEach(function (b) { b.addEventListener('click', function () { self.step(1); }); });
      var raf = 0;
      this.onScroll = function () {
        if (!raf) raf = requestAnimationFrame(function () { raf = 0; self.sync(); });
      };
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.sync();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onScroll);
    }

    buildDots() {
      var self = this;
      var label = this.getAttribute('data-dot-label') || 'Go to slide';
      this.dots.textContent = '';
      this.slides.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sfh-dot';
        b.setAttribute('aria-label', label + ' ' + (i + 1));
        b.addEventListener('click', function () { self.go(i); });
        self.dots.appendChild(b);
      });
    }

    offsetOf(i) { return this.slides[i].offsetLeft - this.slides[0].offsetLeft; }

    // Slide whose start is closest to the scroll position.
    current() {
      var x = this.track.scrollLeft;
      var best = 0;
      var dist = Infinity;
      for (var i = 0; i < this.slides.length; i++) {
        var d = Math.abs(this.offsetOf(i) - x);
        if (d < dist) { dist = d; best = i; }
      }
      return best;
    }

    // Last slide that can still sit at the start (three review cards show at once on desktop).
    lastStart() {
      var max = this.track.scrollWidth - this.track.clientWidth;
      for (var i = 0; i < this.slides.length; i++) if (this.offsetOf(i) >= max - 2) return i;
      return this.slides.length - 1;
    }

    go(i) {
      var n = this.slides.length;
      i = ((i % n) + n) % n;
      this.track.scrollTo({ left: this.offsetOf(i), behavior: 'smooth' });
    }

    step(d) {
      var last = this.lastStart();
      var next = this.current() + d;
      if (next > last) next = 0;
      else if (next < 0) next = last;
      this.go(next);
    }

    sync() {
      var i = this.current();
      if (this.dots) {
        Array.prototype.forEach.call(this.dots.children, function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }
      if (this.bar) {
        // Starts at 1/n like the competitor's bar and fills to 100% at the end of the row.
        var n = this.slides.length;
        var max = this.track.scrollWidth - this.track.clientWidth;
        var progress = max > 0 ? Math.min(1, this.track.scrollLeft / max) : 1;
        this.bar.style.width = ((1 + (n - 1) * progress) / n * 100).toFixed(2) + '%';
      }
      if (i !== this.index) {
        this.index = i;
        this.dispatchEvent(new CustomEvent('sfh:slide', { bubbles: true, detail: { index: i, slide: this.slides[i] } }));
      }
    }
  }

  customElements.define('sf-home-slider', SfHomeSlider);
})();
